import * as Yup from 'yup';

/** Helpers (mirrors the covers/marine style) */
const toOptionalNumber = (schema: Yup.NumberSchema<number | undefined>) =>
  schema.transform((val, orig) =>
    orig === '' || orig === null || typeof orig === 'undefined'
      ? undefined
      : val
  );

const requiredText = () => Yup.string().trim().required('Required');

const requiredNumber = () =>
  toOptionalNumber(Yup.number().required('Required'));

const requiredYear = () =>
  toOptionalNumber(
    Yup.number().typeError('Invalid Number').required('Required')
  );

export const bankersRowSchema = () =>
  Yup.object({
    branchName: requiredText(),
    isMain: requiredText(),
    isAgency: requiredText(),
    employeeNumber: requiredNumber(),
    underwritingYear: requiredYear(),
    infedility: requiredNumber(),
    burglary: requiredNumber(),
    holdup: requiredNumber(),
    inSafe: requiredNumber(),
    inTransit: requiredNumber(),
    forgedCheques: requiredNumber(),
    counterfeitCurrencies: requiredNumber(),
    clause6: requiredNumber(),
    falsification: requiredNumber()
  });

/** Form-level schema */
export const bankersValidationSchema = () =>
  Yup.object({
    bankersDetails: Yup.array()
      .of(bankersRowSchema())
      .min(1, 'At least one row is required')
  });
